import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import Topbar from '../../components/Bar/Topbar'
import Header from '../../components/Bar/Header'
import Footer from '../../components/Footer/Footer'

import { useParams } from 'react-router-dom'
import ProfilCarComp from '../../components/CarParc/ProfilCarComp'



const ProfilCar = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
   const { titre } = useParams();
  return (
    <motion.div
    className=''
      style={{background:'#000'}}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeOut' }}
    >
      <Topbar />
      <Header />
     
       <ProfilCarComp />
    
     
      <Footer />
    </motion.div>
  )
}

export default ProfilCar
